import * as React from "react";

const SvgIcnPause = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 10 16" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 0a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h2zm6 0a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1h2z"
        />
    </svg>
);

export default SvgIcnPause;
